<template>
  <div class="container">
    <div @click="fnShowInfo" class="goods-info-info-wrap">
      <div @click.stop class="content">
        <svg class="icon-svg close" aria-hidden="true" @click="fnShowInfo">
          <use :xlink:href="$globalIcon.closeIconNew"></use>
        </svg>
        <div class="content-wrap">
          <div class="head">
            <div class="head-box">
              <div class="left">
                <div class="img-box" @click="fnPreviewImage(productInfo.pic)">
                  <img alt :src="productInfo ? productInfo.pic : '' | imageToHttps" />
                </div>
              </div>
              <div class="right">
                <div class="jq">
                    <span class="price-range" v-if="priceInfo && priceInfo.minOriginPrice && priceInfo.maxOriginPrice && btnType === 9">
                      <span>
                        <span class="yuan">￥</span>
                        <span class="rmb">{{ priceInfo.minOriginPrice |formatPrice | formatPriceInt }}</span>
                        <span class="float-number">.{{priceInfo.minOriginPrice|formatPrice | formatPriceFloat}}</span>
                      </span>
                      <div class="price-devider"></div>
                      <span>
                        <span>{{ priceInfo.maxOriginPrice |formatPrice | formatPriceInt }}</span>
                        <span class="float-number">.{{priceInfo.maxOriginPrice|formatPrice | formatPriceFloat}}</span>
                      </span>
                    </span>
                    <span class="price-range" v-else-if="priceInfo && priceInfo.minPrice && priceInfo.maxPrice && btnType !== 9">
                      <span>
                        <span class="yuan">￥ </span>
                        <span class="rmb yuan-int">{{ priceInfo.minPrice |formatPrice | formatPriceInt }}</span>
                        <span class="float-number">.{{priceInfo.minPrice|formatPrice | formatPriceFloat}}</span>
                      </span>
                      <div class="price-devider"></div>
                      <span>
                        <span>{{ priceInfo.maxPrice |formatPrice | formatPriceInt }}</span>
                        <span class="float-number">.{{priceInfo.maxPrice|formatPrice | formatPriceFloat}}</span>
                      </span>
                    </span>
                    <!-- <span v-else-if="productInfo.price || productInfo.price === 0"> -->
                    <span v-else-if="priceInfo && (priceInfo.price || priceInfo.price === 0)">
                      <span class="yuan">￥ </span>
                      <span class="rmb yuan-int">{{ ((btnType===4 || btnType === 9) ? priceInfo.originPrice:priceInfo.price) |formatPrice | formatPriceInt}}</span>
                      <span class="dot-after">.{{ ((btnType===4 || btnType === 9) ? priceInfo.originPrice:priceInfo.price) |formatPrice | formatPriceFloat }}</span>

                    </span>
                </div>
                <!-- 多规格 未选规格时不展示到手价 -->
                <template v-if="!(sgAttribute && sgStoreAttribute && Number(attrLength) === 0)"> 
                  <p class="price-quan" v-if="getGoodsUseCouponInfo && getGoodsUseCouponInfo.voucherLen && getGoodsUseCouponInfo.type=='sheng' && this.baseInfo.showCoupons && activityInfo?.activityType !== 100">预计到手价{{getGoodsUseCouponInfo.price.toFixed(2)}}</p>
                  <p class="price-quan" v-if="getGoodsUseCouponInfo && getGoodsUseCouponInfo.voucherLen && getGoodsUseCouponInfo.isCouponReceived && activityInfo?.activityType !== 100">预计到手价{{getGoodsUseCouponInfo.yhprice.toFixed(2)}}</p>
                </template>
                <template v-if="!isExclusive">
                  <div class="member-price" v-if="priceInfo && priceInfo.minPlusPrice && priceInfo.maxPlusPrice && isShowMemberPrice">
                    <span>￥{{priceInfo.minPlusPrice | formatPrice}}-{{priceInfo.maxPlusPrice | formatPrice}}</span>
                    <img src="//cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/plus.png"/>
                  </div>
                  <div class="member-price" v-else-if="priceInfo && priceInfo.plusPrice && isShowMemberPrice">
                    <span>￥{{priceInfo.plusPrice | formatPrice}}</span>
                    <img src="//cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/plus.png"/>
                  </div>
                </template>

                <!-- 佣金 -->
                <commission-label 
                  class="commission-w"
                  :storeId="storeInfo?.o2oStoreId"
                  :mdCode="storeInfo?.mdCode"
                  :commissionType="priceInfo.commissionType"
                  :commission="priceInfo.maxCommission?priceInfo.maxCommission:priceInfo.commission"
                  :bounty="priceInfo.bounty"
                  :more='priceInfo && priceInfo.maxCommission'/>
                <template v-if="baseInfo.showStockNum">
                  <div class="kc" v-if="btnType !==3 && (productInfo.price || productInfo.price === 0) && !sgStockInfo.bookable">库存{{ showStockNum }}件</div>
                  <div class="yx">{{ attrSelected }}</div>
                </template>
              </div>
            </div>
          </div>
          <div class="scroll-view goods-info-info-wrap-content">
            <div class="content-detail">
              <div :key="index" class="content-detail-inner" v-for="(item, index) in attrsMap" :class="index === Object.keys(attrsMap).length-1  ? '__last' : ''">
                <div class="content-detail-inner-tit">{{ item[0].attrName }}</div>
                <div class="content-detail-inner-list">
                  <template v-for="v in item">
                    <!--专属价只显示专属价规格的-->
                    <div v-if="isExclusive && isInAttr(v.sgAttribute.id)" class="content-detail-inner-item active" :key="v.id">
                      {{ v.sgAttribute.attrValueName}}
                    </div>
                     <!--非专属价-->
                    <div
                      :class="{ active: isSelected(v.sgAttribute.id), disable: !isEnable(v.sgAttribute.id, index) }"
                      :key="v.id"
                      @click="handleSelectedAttr(v.sgAttribute.id, index, v)"
                      class="content-detail-inner-item"
                      v-if="!isExclusive"
                    >
                      {{ v.sgAttribute.attrValueName}}
                    </div>
                  </template>
                </div>
              </div>
              <div class="content-detail-inner1" v-if="!hideCount">
                <div class="left">数量
                  <span class="limit" v-if="activityLimitFlag">限购{{activityInfo.quantity}}件,还可购买{{activityInfo.limitNum}}件</span>
                  <span class="limit" v-else-if="showLimitNum">限购{{sgStockInfo.limitNum}}件</span>
                </div>
                <div class="right">
                <div class="customer-stepper">
                  <div class="reduce-btn-wrapper">
                    <svg class="icon-svg reduce-icon" :class="{'unusable':goodsNum <= 1}" aria-hidden="true">
                      <use xlink:href="#icon-ic_jianhao"></use>
                    </svg>
                    <div class="touch-area" @touchend="reduce"></div>
                  </div>
                  <input type="number" v-model="goodsNum" class="num-input" :disabled="disabsedInput" :min="minGoodsNum" :max="maxGoodsNum" @change="fnChangeProductNumber" />
                  <div class="plus-btn-wrapper">
                    <svg class="icon-svg plus-icon" :class="{'unusable':plusIconGray}" aria-hidden="true">
                      <use xlink:href="#icon-ic_jiahao"></use>
                    </svg>
                    <div class="touch-area" @touchend="plus"></div>
                  </div>
                </div>
                </div>
              </div>
              <!-- 花呗分期 -->
              <div class="alipay-fenqi" v-if="hbFqInfo?.length">
                <h4>花呗分期</h4>
                <div class="fenqi-warp">
                  <div class="fenqi-list">
                    <div class="fenqi-item" v-for="(item,index) in hbFqInfo" :key="index" :class="{'active': hbIndex == index }"><!--@click="changeStageFn(item,index)" -->
                      <span v-if="!item.feeRatio">免息</span>
                      <h6>￥{{item.eachAmount | formatPrice}}×{{item.num}}期</h6>
                      <p>手续费预估￥{{item.eachFee | formatPrice}}/期</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="alipay-fenqi" v-if="xjFqInfo?.length">
                <h4>消金分期</h4>
                <div class="fenqi-warp">
                  <div class="fenqi-list">
                    <div class="fenqi-item" v-for="(item,index) in xjFqInfo" :key="index" :class="{'active': hbIndex == index }"><!--@click="changeStageFn(item,index)" -->
                      <span v-if="!item.feeRatio">免息</span>
                      <h6>￥{{item.eachAmount | formatPrice}}×{{item.num}}期</h6>
                      <p>手续费预估￥{{item.eachFee | formatPrice}}/期</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           <div class="btn-container" :class="{'disabled':notSaleStatus || activityDisabledFlag}">
                <template v-if="notSaleStatus">
                  <div class="btn-List-tow">
                    <div class="confirm-btn add-cart"><span>加入购物车</span></div>
                    <div class="confirm-btn" :class="{'orange': !(activityInfo && activityInfo.activityType === 70) && getGoodsUseCouponInfo && getGoodsUseCouponInfo.voucherLen && getGoodsUseCouponInfo.type == 'sheng'}">
                      <span>{{checkCouponIsAllGet ? '立即购买' : '领券购买'}}</span>
                      <h6 v-if="getGoodsUseCouponInfo && getGoodsUseCouponInfo.voucherLen && getGoodsUseCouponInfo.type=='sheng' ">到手价{{getGoodsUseCouponInfo.price.toFixed(2)}}</h6>
                    </div>
                  </div>
                </template>
                <template v-else-if="attrLength < attrsMap.length">
                    <!-- <div class="confirm-btn" :class="{'btn-flex': canSetPrice}"> -->
                    <div class="confirm-btn" @click="attrUnSelectToast">
                      <!-- <span v-if="canSetPrice" class="btn-set-price" @click="manageSetPrice">一键改价</span> -->
                      <span>确定</span>
                    </div>
                </template>
                <template v-else>
                  <template v-if="isShowNoStockBtn">
                        <div class="confirm-btn yellow" @click="fnArrivalNotice"><span>到货通知</span></div>
                  </template>
                  <template v-else>
                    <template v-if="btnType===11">
                      <div class="btn-List-tow">
                        <div class="confirm-btn" @click="confirm('original')">
                          <div class="origin-price">
                            <span>￥</span>{{ priceInfo.minOriginPrice || priceInfo.originPrice || 0 | formatPrice | formatPriceInt }}<span class="right">.{{ priceInfo.minOriginPrice || priceInfo.originPrice || 0 | formatPrice | formatPriceFloat}}</span>
                          </div>
                          <span class="text">原价购买</span>
                        </div>
                        <div v-if="hasActivityStock" @click="confirm" class="confirm-btn" style="background: #FF5252;">
                          <div class="origin-price">
                            <span>￥</span>{{(priceInfo.minPrice || priceInfo.price || 0) | formatPrice | formatPriceInt}}<span class="right">.{{(priceInfo.minPrice || priceInfo.price || 0) | formatPrice | formatPriceFloat}}</span>
                          </div>
                          <span class="text">拼团购买</span>
                        </div>
                        <template v-else>
                              <div class="confirm-btn yellow" @click="fnArrivalNotice"><span>到货通知</span></div>
                        </template>
                      </div>
                    </template>
                    <!-- 确认按钮 -->
                    <template v-if="btnType===0 || btnType===1 || btnType === 9 || btnType === 10">
                      <template v-if="canSetPrice && btnType != 0">
                        <div class="confirm-btn" :class="{'btn-flex': canSetPrice}"><span v-if="canSetPrice" class="btn-set-price" @click="manageSetPrice">一键改价</span><span @click="confirm">确定</span></div>
                      </template>
                      <template v-else>
                        <div class="confirm-btn" @click="confirm"><span>{{ btnType == 1 ? '立即购买' : '确定' }}</span></div>
                      </template>
                    </template>

                    <div class="confirm-btn yellow" v-if="(btnType===2 || (sgStockInfo && !sgStockInfo.hasStock && attrLength === attrsMap.length && !parentBookable && !sgStockInfo.bookable)) && !notSaleStatus" @click="confirm"><span>到货通知</span></div>
                    <div class="confirm-btn zise " v-if="btnType===8" @click="confirm"><span>立即预约</span></div>
                    <div class="confirm-btn red" v-if="btnType===3" @click="confirm"><span>立即预定</span></div>
                    <div class="confirm-btn full" v-if="btnType===4" @click="confirm"><span>原价购买</span></div>
                    <div class="confirm-btn zise" v-if="btnType===5" @click="confirm"><span><span v-if="activityInfo.deposit !== 1">￥{{ priceInfo.price ? priceInfo.price : 0 | formatPrice }}</span>{{activityInfo.deposit === 1 ?'支付订金' : '订金支付'}}</span></div>
                    <div class="btn-List-tow" v-if="btnType===6">
                      <div class="confirm-btn add-cart" v-if="baseInfo.supportCart"><span v-if="canSetPrice" @click="manageSetPrice">一键改价</span><span v-else @click="addCart">加入购物车</span></div>
                      <div class="confirm-btn" :class="{'orange': !(activityInfo && activityInfo.activityType === 70) && getGoodsUseCouponInfo && getGoodsUseCouponInfo.voucherLen && getGoodsUseCouponInfo.type == 'sheng'}" @click="buy">
                        <span>{{ activityInfo && activityInfo.activityType === 70 ? '立即抢购' : checkCouponIsAllGet ? '立即购买' : '领券购买' }}</span>
                        <h6 v-if="getGoodsUseCouponInfo && getGoodsUseCouponInfo.voucherLen && getGoodsUseCouponInfo.type=='sheng'">到手价{{getGoodsUseCouponInfo.price.toFixed(2)}}</h6>
                      </div>
                    </div>
                    <div class="btn-List-tow" v-if="btnType===7">
                      <div class="confirm-btn full" @click="fullBuy"><span>原价购买</span></div>
                      <div class="confirm-btn zise" @click="depositBuy"><span><span v-if="activityInfo.deposit !== 1">￥{{ priceInfo.price ? priceInfo.price : 0 | formatPrice }}</span>{{activityInfo.deposit === 1 ?'支付订金' : '订金支付'}}</span></div>
                    </div>
                  </template>
                </template>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
const commissionLabel = () => import('@/components/commissionLabel/index')

const PRESELL_MAX_NUM = 10
// import Stepper from './stepper'
export default {
  components: { commissionLabel },
  props: [
    // 'isNG',
    // 'internalDiscountPrice',
    'storeInfo',
    'sgAttribute',
    'sgStoreAttribute',
    'productNumber',
    'checkCouponIsAllGet',
    'getGoodsUseCouponInfo',
    'checkedAttr',
    'sgStockInfo',
    'stepperNum',
    'hbFqInfo',
    'xjFqInfo',
    'ioucInfo',
    'isExclusive',
    'canSetPrice',
    'btnType',
    'hasSubProduct',
    'activityInfo',
    'attrLength',
    'priceInfo',
    'parentBookable',
    'notSaleStatus',
    'baseInfo',
    'products',
    'limitSkku',
    'hideCount',
    'settings',
  ],
  data() {
    return {
      goodsNum: 1,
      productInfo: {}, // 根据规格筛选出的商品信息
      checkedAttrIdsArr: [], // 选择的规格ID
      checkedAttrIdsStr: '', // 选择的规格ID
      attrName: '', // 规格组合名字
      filterAttrs: [], // 可选规格组合筛选后的数据
      originAttrs: [], // 可选规格组合原始数据
      attrsMap: [], // 规格参数，添加selected,enable字段
      priceArr: [], // 价格
      newSgStockInfo: {},
      // priceRange: '', // 多规格时未选中状态展示价格区间
      maxPrice: 0, // 最高价格
      minPrice: 0, // 最高价格
      checkedAttrTypeArr: [], // 已选规格类型
      isShowMemberPrice: this.$util.isShowMemberPrice(), // 是否可以显示会员价
      hbIndex: -1, // 当前点击的分期
      payNum:0, // 花呗分期数
    }
  },
  mounted() {
    console.log(this.$options.propsData, '=====props=====')
    this.initializationCheck()
    if (this.hasSubProduct) {
      // 多规格默认选中 购买数量 1 ，默认不选中 购买数量 0
      this.goodsNum = this.checkedAttr ? 1 : 0
    } else {
      this.goodsNum = this.productNumber
    }
  },
  computed: {
    // 配件商品
    isAccessoryProduct() {
      return this.products?.platTagIds?.includes(22)
    },
    // 展示商品限购
    showLimitNum() {
      return this.isAccessoryProduct && this.sgStockInfo.limitNum >= 1
    },
    attrSelected() {
      return this.attrName.length > 28 ? this.attrName.slice(0, 28) + '...' : this.attrName
    },
    // 预售
    isPreSell() {
      return this.btnType === 3
    },
    plusIconGray () {
      // 如果在限购活动中goodsNum >= 可购买数量时 加号变灰
      if (this.activityLimitFlag) {
        return this.goodsNum >= this.activityInfo.limitNum
      } else if (this.isPreSell) {
        return this.goodsNum >= PRESELL_MAX_NUM
      } else {
        if (this.activityInfo && this.activityInfo.stock > 0) {
          return this.goodsNum >= this.activityInfo.stock
        } else if (this.sgStockInfo && this.sgStockInfo.limitNum) {
          if (this.sgStockInfo.bookable || this.parentBookable || (this.products && this.products.isNoLimitStockProduct)) {
            return this.goodsNum >= Math.min(this.sgStockInfo.limitNum, 500)
          }
          return this.goodsNum >= Math.min(this.sgStockInfo.stockNum, this.sgStockInfo.limitNum, 500)
        } else {
          if (this.sgStockInfo.bookable || this.parentBookable || (this.products && this.products.isNoLimitStockProduct)) {
            return this.goodsNum >= 500
          } else {
            if (this.sgStockInfo.bookable || this.parentBookable) {
              return this.goodsNum >= 500
            } else {
              if (this.sgStockInfo.bookable || this.parentBookable) {
                return this.goodsNum >= 500
              } else {
                return this.goodsNum >= Math.min(this.sgStockInfo.stockNum, 500)
              }
            }
          }
        }
      }
    },
    /**
     * @description 限购活动标志
     */
    activityLimitFlag() {
      return this.btnType !== 4 && this.btnType !== 9 && this.activityInfo && this.activityInfo.limitNum !== undefined && this.activityInfo.limitNum !== null && this.activityInfo.quantity !== null
    },
    /**
     * @description 限购活动中可购买数量是否为0
     */
    activityDisabledFlag() {
      return this.activityLimitFlag && this.activityInfo.limitNum === 0
    },
    minGoodsNum() {
      return this.activityDisabledFlag || (this.productInfo && !this.sgStockInfo.bookable && this.productInfo.stockNum === 0) ? 0 : 1
    },
    maxGoodsNum() {
      let num = 0
      if (this.activityLimitFlag) {
        num = this.activityInfo.limitNum
      } else if (this.isPreSell) {
        num = PRESELL_MAX_NUM
      } else {
        // num = this.products && this.products.isNoLimitStockProduct ? 500 : this.productInfo ? this.productInfo.stockNum > 500 ? 500 : this.productInfo.stockNum : 1
        // Math.min(this.sgStockInfo.stockNum, this.sgStockInfo.limitNum || Infinity, 500)
        if ((this.sgStockInfo && this.sgStockInfo.bookable) || (this.products && this.products.isNoLimitStockProduct)) {
          num = Math.min(this.sgStockInfo.limitNum || Infinity, 500)
        } else {
          num = Math.min(this.sgStockInfo.stockNum, this.sgStockInfo.limitNum || Infinity, 500)
        }
      }

      return num
    },
    disabsedInput() {
      return this.activityDisabledFlag || (this.productInfo && this.productInfo.stockNum === 0 && !this.sgStockInfo.bookable && !(this.products && this.products.isNoLimitStockProduct))
    },
    // 显示库存
    showStockNum() {
      let num = 0;
      if ([10, 11].indexOf(this.btnType) !== -1 && this.activityInfo && (this.activityInfo.stock || this.activityInfo.stock === 0)) {
        num = Math.min(this.activityInfo.stock, this.sgStockInfo.stockNum)
      } else if (this.sgStoreAttribute.length > 1 && this.productInfo) {
        num = this.productInfo.num
      }else {
        num = this.sgStockInfo ? this.sgStockInfo.stockNum : 0
      }
      return num;
    },
    // 是否有活动库存
    hasActivityStock() {
      return (this.activityInfo && this.activityInfo.stock > 0) || (this.activityInfo.stock === null && this.sgStockInfo && this.sgStockInfo.hasStock);
    },
    // 是否显示到货通知
    isShowNoStockBtn() {
      return (this.activityInfo && this.activityInfo.stock === 0 && [10, 11].indexOf(this.btnType) !== -1 && this.sgStockInfo && !this.sgStockInfo.hasStock) || (this.sgStockInfo && !this.sgStockInfo.hasStock && !this.parentBookable && !this.sgStockInfo.bookable && !this.notSaleStatus);
    }
  },
  filters: {
    formatPriceInt(v) {
      return v.split('.')[0];
    },
    formatPriceFloat(v) {
      return v.split('.')[1];
    }
  },
  watch: {
    activityLimitFlag () {
      this.fnChangeProductNumber()
    },
    productNumber(val) {
      this.goodsNum = val
    },
    /**
     * @description 在限购活动中，如果可购买数量为0，则把goodsNum置为0
     */
    activityDisabledFlag: {
      handler(val) {
        if (val) {
          this.goodsNum = 0
        } else {
          this.goodsNum = 1
        }
      },
      immediate: true
    },
    sgStoreAttribute: {
      handler: function (newValue, oldValue) {
        this.originAttrs = newValue
        if (this.checkedAttr) {
          // 如果已有选中项，用这个
          this.checkedAttrIdsStr = this.checkedAttr
        }
        this.checkedAttrIdsArr = this.checkedAttrIdsStr != undefined ? this.checkedAttrIdsStr.split(',').map(v => parseInt(v)) : []
        // 筛选商品信息
        this.combineProductInfo()
      },
      // deep: true,
      immediate: true
    },
    priceInfo: {
      handler: function (newValue, oldValue) {
        if (this.hasSubProduct) {
          // 多规格商品 规格选择完整后 价格 取动态接口配置
          if (this.attrLength === this.attrsMap.length) {
            if (this.productInfo.price !== newValue.price) {
              this.productInfo.price = newValue.price
            }
          }
        }
      },
      deep: true,
      // immediate: true
    },
    sgAttribute: {
      handler: function(newValue, oldValue) {
        this.attrsMap = []
        // 将规格对象转换为数组
        for (let key in newValue) {
          let v = newValue[key]
          this.attrsMap.push(v)
        }
        console.log('attrsMap:', this.attrsMap)
        console.log(this.attrsMap)
      },
      immediate: true
    },
    checkedAttrIdsArr: {
      handler: function(newVal, oldVal) {
        let checkedAttrNamesArr = []
        this.checkedAttrTypeArr = []
        newVal.forEach((v, i) => {
          this.attrsMap[i].forEach(item => {
            if (item.sgAttribute.id == v) {
              checkedAttrNamesArr.push(item.sgAttribute.attrValueName)
              this.checkedAttrTypeArr.push(item.attrName)
            }
          })
        })
        this.attrName = checkedAttrNamesArr.join(',')
        this.$emit('attrNameChange', this.attrName)
      },
    },
    sgStockInfo: {
      deep: true,
      handler(newVal, oldVal) {
        this.productInfo.stockNum = newVal.stockNum;
        // 1)预定商品 2)无需校验库存商品 不做库存限制
        if ((newVal.stockNum > 0 || (this.sgStockInfo.bookable || this.parentBookable) || (this.products && this.products.isNoLimitStockProduct)) && !this.activityDisabledFlag) {
          if (this.goodsNum === 0) {
            this.goodsNum = 1
          }
        } else {
          this.goodsNum = 0
        }
      }
    }
  },
  methods: {
    /**
     * @description 到货通知
     */
    fnArrivalNotice() {
      if (this.notSaleStatus) return
      this.$emit('fnArrivalNotice')
    },
    // 更改分期方式
    changeStageFn(item, index) {
      if(this.hbIndex === index){
        this.hbIndex = -1
        this.payNum = 0
      }else{
        this.hbIndex = index
        this.payNum = item.num
      }
      this.$emit('fnHb',this.hbIndex, this.payNum)
    },
    /**
     * @description  数量减操作
     */
    reduce() {
      if (this.activityDisabledFlag || this.goodsNum<=1) return
      this.goodsNum = Number(this.goodsNum) === 0 ? 0 : Number(this.goodsNum) - 1
      this.fnChangeProductNumber()
    },
    /**
     * @description  数量加操作
     */
    plus() {
      console.log('plus')
      if (this.plusIconGray) return
      this.goodsNum = Number(this.goodsNum) >= 500 ? 500 : (Number(this.goodsNum) + 1)
      this.fnChangeProductNumber()
    },
    /**
     * @description  初始化选中名称
     */
    initializationCheck() {
      // if (!this.hasSubProduct) {
      let checkedAttrNamesArrs = []
      this.checkedAttrIdsArr.forEach((v, i) => {
        console.log(i)
        console.log(this.attrsMap[i])
        this.attrsMap[i].forEach(item => {
          if (item.sgAttribute.id == v) checkedAttrNamesArrs.push(item.sgAttribute.attrValueName)
        })
      })
      this.attrName = checkedAttrNamesArrs.join(',')
      this.$emit('attrNameChange', this.attrName)
      // }
    },
    /**
     * 是否在已选属性内
     */
    isInAttr(id) {
      // console.log('+++++++++++', id, this.checkedAttrIdsStr?.split(','))
      return this.checkedAttrIdsStr?.split(',').includes('' + id)
    },
    /**
     * @description  判断某规格是否可选
     * @param {string} id 规格id
     * @param {number} parentIndex 规格分类下标
     */
    isEnable(id, parentIndex) {
      let tmpCheckedAttrIdsArr = [...this.checkedAttrIdsArr]
      let tmpFilterAttrs = [...this.originAttrs]
      tmpCheckedAttrIdsArr.forEach((checkedAttr, index) => {
        if (index !== parentIndex && checkedAttr) {
          tmpFilterAttrs = tmpFilterAttrs.filter((v, i) => v.attrValueIds.indexOf(checkedAttr) !== -1)
        }
      })
      for (const filter of tmpFilterAttrs) {
        if (this.sgStockInfo.bookable) {
          // 马上预定的商品 只禁用上级规格不对应的下级规格
          if (filter.attrValueIds.indexOf(id) !== -1) {
            if (this.limitSkku) {
              if (this.limitSkku.indexOf(filter.skku) !== -1) {
                return true
              }
            } else {
              return true
            }
          }
        } else {
          if (!this.hasSubProduct) {
            return true
          } else {
            // 非马上预定 增加库存数限制 ，静态接口无库存 禁用 sgStockInfo && !sgStockInfo.stockNum
            console.log('filter.attrValueIds===>', filter.attrValueIds, 'id==>', id, filter.num, 'filter==>', filter, this.limitSkku)
            if (filter.attrValueIds.indexOf(id) !== -1 && (filter.num && filter.num > 0)) {
              if (this.limitSkku) {
                if (this.limitSkku.indexOf(filter.skku) !== -1) {
                  return true
                }
              } else {
                return true
              }
            }
          }
        }
      }
      return false
    },
    /**
     * @description  判断某规格是否选中
     * @param {string} id 规格id
     */
    isSelected(id) {
      return this.checkedAttrIdsArr.indexOf(id) !== -1
    },
    /**
     * @description  选择某个规格
     * @param {string} id 所选规格id
     * @param {number} parentIndex 规格分类下标
     * @param {object} item 选中的规格
     */
    handleSelectedAttr(id, parentIndex, item) {
      if (this.isExclusive) return // 专属价不处理
      if (!this.hasSubProduct) return // 单规格商品不可切换
      if (!this.isEnable(id, parentIndex)) return
      // 替换选择的规格ID, 如果是取消选中，id赋值null
      let tmpAttrId = this.isSelected(id) ? null : id
      this.$set(this.checkedAttrIdsArr, parentIndex, tmpAttrId)
      this.combineProductInfo()
      this.goodsNum = 1
      this.$emit('changeGoodsNumber', this.goodsNum)
      this.$emit('fnSelectAttribute', this.productInfo)
      this.$emit('changeAttribute', item)
    },
    /**
     * @description 规则未选完整提示
    */
    attrUnSelectToast() {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      if (this.checkedAttrTypeArr.length < this.attrsMap.length) {
        let unSelectList = []
        this.attrsMap.forEach(i => {
          if (this.checkedAttrTypeArr.indexOf(i[0].attrName) === -1) {
            unSelectList.push(i[0].attrName)
          }
        })
        this.$toast(`请选择 ${unSelectList.join(',')}`)
      }
    },
    // 筛选商品信息
    combineProductInfo() {
      this.checkedAttrIdsStr = this.checkedAttrIdsArr.join(',')
      this.productInfo = {}
      let attrIds = (this.checkedAttrIdsStr || '').split(',').sort().join(',')
      for (const v of this.originAttrs) {
        let valueIds = (v.attrValueIds || '').split(',').sort().join(',')
        if (attrIds === valueIds) {
        // if (this.checkedAttrIdsStr === v.attrValueIds) {
          // this.priceRange = ''
          this.productInfo = v
          // if ((this.productInfo.price || this.productInfo.price === 0) && this.productInfo.price !== 'NaN') {
          //   this.priceArr = (parseFloat(this.productInfo.price).toFixed(2) + '').split('.')
          // } else {
          //   this.priceArr = ['0']
          // }
          break
        }
      }
      if (!this.productInfo.attrIds) {
        // 无选中状态 针对多规格商品处理 1) 展示图片取默认第一张 2)计算所有规格价格区间
        this.$emit('priceValue', '')

        if (this.hasSubProduct) {
          this.productInfo = {
            pic: this.originAttrs[0].pic
          }
        }
      } else {
        // this.$emit('priceRange', '')
        this.$emit('priceValue', this.productInfo.price)
      }
      console.log('.productInfo.price', this.productInfo.price)
    },
    fnShowInfo() {
      this.$emit('fnShowInfo')
    },
    fnPreviewImage(pic) {
      let images = [pic]
      ImagePreview({
        images,
        startPosition: 0,
        onClose() {
          // do something
        },
      })
    },
    fnChangeProductNumber(value) {
      this.checkNumber()
      this.$emit('fnChangeProductNumber', this.goodsNum)
    },
    /**
     * @description  检查输入数量是否合法
     */
    checkNumber() {
      // if (this.goodsNum < 1 && !this.activityDisabledFlag) {
      //   this.goodsNum = 1
      //   return
      // }
      // DSG-25621
      if (this.activityLimitFlag) {
        this.goodsNum = this.goodsNum > this.maxGoodsNum ? this.maxGoodsNum : this.goodsNum
      } else if (this.isPreSell) {
        this.goodsNum = this.goodsNum > PRESELL_MAX_NUM ? PRESELL_MAX_NUM : this.goodsNum < 1 ? 1 : this.goodsNum 
      } else {
        if (this.activityInfo && this.activityInfo.stock > 0) {
          if (this.goodsNum > this.activityInfo.stock) {
            this.goodsNum = this.activityInfo.stock
          }
        } else if (this.sgStockInfo && this.sgStockInfo.limitNum) {
          if (this.sgStockInfo.bookable || this.parentBookable || (this.products && this.products.isNoLimitStockProduct)) {
            const limitNum = Math.min(this.sgStockInfo.limitNum || Infinity, 500)
            if (this.goodsNum > limitNum) {
              this.goodsNum = limitNum
              this.$toast(`最多购买${limitNum}件~`)
            }
          } else {
            const limitNum = Math.min(this.sgStockInfo.stockNum, this.sgStockInfo.limitNum || Infinity, 500)
            if (this.goodsNum > limitNum) {
              this.goodsNum = limitNum
              this.$toast(`最多购买${limitNum}件~`)
            }
          }
        } else {
          if (this.sgStockInfo.bookable || this.parentBookable || (this.products && this.products.isNoLimitStockProduct)) {
            const limitNum = 500
            if (this.goodsNum > limitNum) {
              this.goodsNum = limitNum
            }
          } else {
            const limitNum = Math.min(this.sgStockInfo.stockNum, 500)
            if (this.goodsNum > limitNum) {
              this.goodsNum = limitNum
            }
          }
        }

        // if (!this.sgStockInfo.limitNum && this.products.isNoLimitStockProduct) {
        //   if (this.goodsNum > 500) this.goodsNum = 500
        // } else {
        //   const limitNum = Math.min(this.sgStockInfo.stockNum, this.sgStockInfo.limitNum || Infinity, 500)
        //   if (this.goodsNum > limitNum) {
        //     this.goodsNum = limitNum
        //     if (this.sgStockInfo.limitNum && this.sgStockInfo.limitNum <= this.sgStockInfo.stockNum) {
        //       this.$toast(`为了您的购物体验，当前商品一次购买数量不超过${this.sgStockInfo.limitNum}`)
        //     }
        //   }
        // }
      }
    },
    fnAddCart() {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      this.$emit('fnAddCart')
    },
    fnGoBuy() {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      this.$emit('fnGoBuy')
    },
    /**
     * @description  确定
     */
    confirm(type) {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      if ((this.goodsNum > 0 && this.attrSelected) || this.btnType === 2) {
        this.$emit('attrConfirm', { type, num: this.goodsNum })
      }
    },
    /**
     * @description  加购物车
     */
    addCart() {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      if (this.goodsNum > 0 && this.attrSelected) {
        this.$emit('addCart')
      }
    },
    /**
     * @description  立即购买
     */
    buy() {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      if (this.goodsNum > 0 && this.attrSelected) {
        this.$emit('buy')
      }
    },
    depositBuy() {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      if (this.goodsNum > 0 && this.attrSelected) {
        this.$emit('depositBuy')
      }
    },
    fullBuy() {
      if (this.notSaleStatus || this.activityDisabledFlag) return
      if (this.goodsNum > 0 && this.attrSelected) {
        this.$emit('fullBuy')
      }
    },
    manageSetPrice() {
      console.log(this.checkedAttrIdsArr, this.checkedAttrIdsStr)
      if (!this.checkedAttrIdsStr || !this.checkedAttrIdsArr.length) {
        this.$toast('请先选择规格')
        return
      }
      this.$emit('manageSetPrice', 'attr')
    },
    ioucTap(item) {
      // 收银台埋点上报
      let eventId = (this.$util.isSyBird() || this.$util.isSyBirdH5()) ? 'BD20064' : 'HZ20004';
      this.$util.gioTrackWithVariable(eventId, {
        instalments_number: item.num,
        product_id: this.products.productId
      })
    },
  },
}
</script>
<style>
.van-stepper__input {
  margin: 0;
  color:#333;
  border: 1px solid #E4E4E4;
  background-color: #fff;
}
.van-stepper__minus {
  border: 1px solid #E4E4E4;
  border-right: none;
  background-color: #fff;
}
.van-stepper__plus {
  border: 1px solid #E4E4E4;
  border-left: none;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
.commission-w{
  margin-bottom: 0.1rem;
}
.container,.goods-info-info-wrap{
  height: 100%;
  overflow:hidden;
}
.scroll-view.goods-info-info-wrap-content {
  // height: 7.7rem;
  max-height: 4.5rem;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar{
    display: none;
  }
}
.content-wrap{
  position: relative;
  height: 100%;
  padding-bottom: .2rem;
  box-sizing: border-box;
}
.goods-info-info-wrap .content {
  position: relative;
  width: 100%;
  height: 100%;
  /* padding: 0.24rem; */
  padding-bottom: 0;
  box-sizing: border-box;
  border-top-left-radius: 0.24rem;
  border-top-right-radius: 0.24rem;
  background-color: #fff;
}
.goods-info-info-wrap .content .head {
  position: relative;
  padding: 0 .24rem;
  padding-top: .3rem;
  padding-bottom: 0.44rem;
}
.goods-info-info-wrap .content .head .head-box {
  display: flex;
}
.goods-info-info-wrap .content .head .head-box .left .img-box {
  margin: 0 0.24rem 0 0.02rem;
}
.goods-info-info-wrap .content .head .head-box .left .img-box img {
  width: 1.92rem;
  height: 1.92rem;
  // object-fit: cover;
}
.goods-info-info-wrap .content .head .head-box .right {
  /* padding-top: 0.26rem; */
}
.goods-info-info-wrap .content .head .head-box .right .jq {
  color: $themeSynRed;
  font-family: DIN Alternate;
  margin-bottom: .16rem;
  margin-left: -.08rem;
  .yuan{
    font-size: .32rem;
    font-weight: bold;

  }
  .yuan-int{
    margin-left: -0.08rem;
  }
  .yuan-discount{
    margin-left: 0.08rem;
  }
  .rmb{
    font-size: 0.52rem;
    font-weight: bold;
  }
  .dot-after{
    font-size: .32rem;
    font-weight: bold;
  }
  .discount-suffix {
    font-size: 20px!important;
    line-height: 20px!important;
    font-weight: 600!important;
    margin-left: 5px;
    position: relative;
    top: -2px;
  }
}
.goods-info-info-wrap .content .head .head-box .right .kc,
.goods-info-info-wrap .content .head .head-box .right .yx {
  height: .3rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #333;
}
.goods-info-info-wrap .content .head .head-box .right .yx{
  margin-top: .16rem;
}
.goods-info-info-wrap .content .head .head-box .right .kc {
  // margin: 0.16rem 0;
  color: #999999;
}
.goods-info-info-wrap .content >.close {
  position: absolute;
  right: 0.28rem;
  top: 0.34rem;
  width: 0.28rem;
  height: 0.28rem;
  z-index: 10;
  margin: .08rem .08rem 0 0;
}
.goods-info-info-wrap .content .content-detail{
  padding-bottom: 1.4rem;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner {
  padding: 0 .24rem;
  padding-bottom: 0.32rem;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner.__last{
  padding-bottom: 0.2rem;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner .content-detail-inner-tit {
  font-size: 0.28rem;
  font-weight: bold;
  color:#333333;
  padding-bottom: 0.24rem;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner .content-detail-inner-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner .content-detail-inner-item {
  padding: 0.16rem 0.24rem;
  border-radius: 4px;
  background-color: #f2f2f2;
  color: #333;
  font-size: 0.24rem;
  font-weight: 400;
  margin-right: 0.24rem;
  margin-bottom:  0.24rem;
  border:.01rem solid transparent;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner .content-detail-inner-item:last-child {
  margin-right: 0;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner .content-detail-inner-item.active {
  // background: rgba(40, 120, 255, 0.1);
  // border: 0.01rem solid #2283e2;
  color: #fff;
  font-weight: bold;
  @include themeSynMainLinearButton;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner .content-detail-inner-item.disable {
  background: #f5f5f5;
  color: #999999;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner .content-detail-inner-item.normal {
  background: #f5f5f5;
  color: #333333;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner1 {
  padding: 0 .24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: max-content;
  margin-bottom: .48rem;
}
.content-detail-inner1 .left .limit{
  font-size: .4rem;
  color: #ED2856;
  line-height: .28rem;
  margin-left: .16rem;
  transform: scale(0.5);
  transform-origin: bottom left;
  display: inline-block;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner1 .left {
  font-size: 0.28rem;
  font-weight: bold;
  color: #333333;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner1 .right :deep(button) {
  width: 0.8rem !important;
  height: 0.52rem !important;
}
.goods-info-info-wrap .content .content-detail .content-detail-inner1 .right :deep(.van-stepper__input) {
  width: 0.76rem !important;
  height: 0.52rem !important;
}

.customer-stepper{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .reduce-btn-wrapper, .plus-btn-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .touch-area {
    position: absolute;
    top: -15px;
    bottom: -15px;
    z-index: 1;
  }
  .reduce-btn-wrapper .touch-area {
    left: -15px;
    right: 0;
  }
  .plus-btn-wrapper .touch-area {
    right: -15px;
    left: 0;
  }
  .reduce-icon{
    width: .2rem;
    height: .2rem;
    margin-right: .1rem;
    position: relative;
    z-index: 0;
  }
  .plus-icon{
    width: .2rem;
    height: .2rem;
    margin-left: .1rem;
    position: relative;
    z-index: 0;
  }
  .unusable{
    color: #F2F2F2;
  }
  .num-input{
    width: .84rem;
    height: .44rem;
    background-color: #F2F2F2;
    font-size: .24rem;
    color: #333333;
    font-weight: bold;
    text-align: center;
    -moz-appearance: textfield;
    ::-webkit-inner-spin-button{
      -webkit-appearance: none;
    }
    ::-webkit-outer-spin-button{
      -webkit-appearance: none;
    }
  }
}

.alipay-fenqi{
  margin-bottom: .4rem;
  h4{
    padding-left: .24rem;
    margin-bottom: .24rem;
    font-size: .28rem;
    color: #333;
    font-weight: bold;
  }
  .fenqi-warp{
    height: 1.5rem;
    overflow: hidden;
    overflow-y: hidden;
    overflow-x: auto;
    &::-webkit-scrollbar{
      display: none;
    }
  }
  .fenqi-list{
    padding-left: .24rem;
    height: 1.5rem;
    white-space: nowrap;
  }
  .fenqi-item{
    position: relative;
    margin-right: .24rem;
    padding: .32rem;
    width: 2.4rem;
    height: 1.3rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: .16rem;
    background: #f2f2f2;
    box-sizing: border-box;
    >span{
      position: absolute;
      left: 0;
      top: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: .68rem;
      height: .32rem;
      background-image: linear-gradient(65deg, #FF4D21 0%, #FF9B82 100%);
      border-radius: .16rem 0 .16rem 0;
      font-size: .22rem;
      color: #fff;
    }
    /* &:last-child{
      margin-right: 0;
    } */
    h6{
      font-size: .24rem;
      line-height: .34rem;
      color: #333;
      font-family: PingFangSC-Medium;
      font-weight: 500;
    }
    p{
      margin-top: 2px;
      font-size: .2rem;
      color: #999;
    }
    &.active{
      background: #E9F1FF;
      border:1px solid rgba(40,120,255,1);
      div{
        color: #2878FF;
      }
      h6{
        color: #2878FF;
      }
    }
  }
}

.iouc-container{
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .title{
      display: flex;
      align-items: flex-end;
      .title-text{
        font-size: .28rem;
        font-weight: bold;
        color: #333333;
        line-height: .34rem;
      }
      .title-info{
        height: .56rem;
        font-size: .4rem;
        color: #999999;
        line-height: .56rem;
        transform: scale(0.5);
        display: inline-block;
        transform-origin: bottom left;
        margin-bottom: .02rem;
      }
    }
  }
  .iouc-content{
    margin-top: .26rem;
    display: flex;
    overflow-y: hidden;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    .iouc-item{
      width: 120px;
      height: 1rem;
      font-size: .24rem;
      color: #999999;
      background-color: #F2F2F2;
      border-radius: .16rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: .24rem;
      flex-shrink: 0;
      .fee{
        font-size: .2rem;
        margin-top: .08rem;
      }
    }
    ::-webkit-scrollbar {
      display: none;
    }
  }
}
.confirm-btn{
  width: 100%;
  height: .88rem;
  border-radius: .5rem;
  font-size: .32rem;
  font-weight: bold;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @include themeSynMainLinearButton;
  h6{
    padding-top: 2px;
    font-size: .24rem;
  }
}

.btn-flex{
  flex-direction: row;
  background: none;
  span{
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    &.btn-set-price{
      border-top-left-radius: .44rem;
      border-bottom-left-radius: .44rem;
      color: $themeSynMain;
      border: 1px solid $themeSynMain;
    }
    &:last-child{
       border-top-right-radius: .44rem;
      border-bottom-right-radius: .44rem;
      @include themeSynMainLinearButton;
    }
  }
}

.green{
  // background: #01cd52;
  color: #fff;
}
.red {
  background: #ED2856;
}
.zise{
  // background: #6018FF;
  color: #fff;
}
.yellow{
  // background: #ff9e23;
  color: #fff;
}
.add-cart {
  color: $themeSynMain;
  background: #fff;
  border: 0.02rem solid $themeSynMain;
}
.full{
  // background: #FF9E23;
  color: #fff;
}
.blue{
  // background: #2878FF;
  color: #fff;
}
.orange{
  // background: #FF5252;
}
.btn-List-tow{
  width: 100%;
  display: flex;
  justify-content: space-between;
  .confirm-btn:first-child{
    margin-right: .16rem;
  }
}
.btn-container{
  position: absolute;
  left: 0;
  right: 0;
  box-sizing: border-box;
  bottom: 0;
  transform: translateZ(0);
  will-change: auto;
  background: #fff;
  @include max-width;
  padding: 0 .24rem;
  padding-top: 0.2rem;
  > div{
    margin-bottom: .24rem;
  }
}
.price-range{
  font-size: 0.52rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  span{
    font-weight: bold;
  }
  .price-devider{
    width: .18rem;
    height: .04rem;
    background: $themeSynRed;
    margin: 0 .06rem;
  }
}
.price-quan{
  padding-bottom: .1rem;
  font-size: .2rem;
  color: $themeSynRed;
}
.float-number{
  font-size: .32rem;
  font-weight: bold;
  color: $themeSynRed;
}
.btn-container.disabled .confirm-btn{
  opacity: 0.3;
}
.close{
  -webkit-touch-callout: none; /* 禁用系统默认菜单 */
  -webkit-user-select: none;
}
/* 多规格弹窗底部适配 iphonex */
@supports (bottom: env(safe-area-inset-bottom)) {
  .content-wrap{
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
 /* .goods-info-info-wrap,.goods-info-info-wrap .content{
   height: calc(9.6rem + constant(safe-area-inset-bottom));
   height: calc(9.6rem + env(safe-area-inset-bottom));
 } */
}
.member-price {
  opacity: 1;
  margin-bottom: .14rem;
  box-sizing: border-box;
  color: #333;
  justify-content: center;
  font-weight: bold;
  text-align: left;
  font-size: .26rem;
  font-family: DIN Alternate;
  span{
    display: inline-block;
    position: relative;
    top: -.02rem;
    font-size: .26rem;
  }
  img {
    display: inline-block;
    width: .68rem;
    height: .24rem;
  }
}
.origin-price {
  color: white;
  font-family: DIN Alternate;
  span {
    font-size: .24rem;
    display: inline-block;
    transform: scale(.83);
    transform-origin: right;
    position: relative;
    right: .02rem;
  }
  .right {
    transform-origin: left;
    margin-left: .02rem;
  }
}
.text {
  margin-right: .08rem;
  font-weight: bold;
  color: white;
  font-size: .28rem;
}
</style>
